import React, {useContext, useEffect} from 'react';
import AppHeader from "./AppHeader";
import AppFooter from "./AppFooter";
import Routes, {FOOTER_REPORTS_PANEL} from "routes/Routes";
import {Container, Toast} from "react-bootstrap";
import SessionExpiredModal from "components/AgGridToolbar/SessionExpiredModal";
import {SecurityContext} from "context/security";
import Login from "pages/login/Login";
import AuthenticationService, {PROFILE_SESSION_ATTRIBUTE_NAME} from "service/AuthenticationService";
import {ToastContextProvider} from "context/Toast";
import {GridSpinner} from 'components/Spinner/GridSpinner';
import {EntityAccountsContextProvider} from "components/entity-accounts/context";
import {UtilsContextProvider} from "context/utils";
import ExportGridToCsv from "components/ExportGridToCsv";
import {TradeBreakContextProvider, TradeCaptureContextProvider} from "pages/tradecapture/context";
import {ShortSaleContextProvider} from "pages/shortsale/context";
import {ActionPanelContextProvider} from "context/action";
import {WebAnnouncementsContextProvider} from "../pages/admin/webannouncements/context";
import {HomepageContextProvider} from "../pages/home/context";
import {UserPreferencesContextProvider} from "../context/userpreferences";
import {QueriesPanelContextProvider} from "../pages/query/context";
import {ReportsPanelContextProvider} from "../pages/reports/context";
import {useLocation} from "react-router-dom";
import ReactGA from "react-ga4";
import reportWebVitals from "../reportWebVitals";
import {getBusinessFunctionality} from "../utils/PageRoutingMap";
import OneTrustComponent from "../components/OneTrust/OneTrustComponent";
import {AssetTransferContextProvider} from "../pages/wires/context";
import {MnyWiresContextProvider} from "pages/admin/moneywires/context";
import {WireTemplatesContextProvider} from "pages/admin/wiretemplate/context";
import {Redirect, Route, Switch} from "react-router-dom";
import FooterReportsPanel from "../pages/footerreports/FooterReportsPanel";
import {SwiftWiresContextProvider} from "../pages/admin/swiftwires/context";
import {SwiftMessageContextProvider} from "../pages/admin/swift/context";

function AppLayout() {
    const {sessionExpired, needLogin, setNeedLogin} = useContext(SecurityContext);
    reportWebVitals();
    const location = useLocation();
    const profile = JSON.parse(sessionStorage.getItem(PROFILE_SESSION_ATTRIBUTE_NAME) || '{}');
    const mBun = profile.mbun;
    const businessFunctionality = getBusinessFunctionality(location.pathname);

    useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: location.pathname,
            title: businessFunctionality,
            MBUN: mBun
        });
    }, [location]);

    if (AuthenticationService.isUserAuthenticated()) {
        if (needLogin) {
            setNeedLogin(false);
        }
    } else {
        setNeedLogin(true);
    }

    if (needLogin) {
        return <Switch>
            <Route exact path='/' component={Login}/>
            <Route exact path={`${FOOTER_REPORTS_PANEL}/:fileName`} component={FooterReportsPanel}/>
            <Route exact path='/logout' component={Login}/>
        </Switch>
    } else
        return (<>
                <UserPreferencesContextProvider>
                    <UtilsContextProvider>
                        <ToastContextProvider>
                            <QueriesPanelContextProvider>
                                <ReportsPanelContextProvider>
                                    <EntityAccountsContextProvider>
                                        <TradeCaptureContextProvider>
                                            <TradeBreakContextProvider>
                                                <AssetTransferContextProvider>
                                                    <WebAnnouncementsContextProvider>
                                                        <HomepageContextProvider>
                                                            <AppHeader/>
                                                            <Container className="min-vh-100" fluid>
                                                                <ShortSaleContextProvider>
                                                                    <ActionPanelContextProvider>
                                                                        <MnyWiresContextProvider>
                                                                            <WireTemplatesContextProvider>
                                                                                    <SwiftWiresContextProvider>
                                                                                        <SwiftMessageContextProvider>
                                                                                            <OneTrustComponent/>
                                                                                            <Routes/>
                                                                                        </SwiftMessageContextProvider>
                                                                                    </SwiftWiresContextProvider>
                                                                            </WireTemplatesContextProvider>
                                                                        </MnyWiresContextProvider>
                                                                    </ActionPanelContextProvider>
                                                                </ShortSaleContextProvider>
                                                                <GridSpinner/>
                                                                <ExportGridToCsv/>
                                                            </Container>
                                                            <AppFooter/>
                                                        </HomepageContextProvider>
                                                    </WebAnnouncementsContextProvider>
                                                </AssetTransferContextProvider>
                                            </TradeBreakContextProvider>
                                        </TradeCaptureContextProvider>
                                    </EntityAccountsContextProvider>
                                </ReportsPanelContextProvider>
                            </QueriesPanelContextProvider>
                        </ToastContextProvider>
                    </UtilsContextProvider>
                </UserPreferencesContextProvider>
                {sessionExpired && <SessionExpiredModal/>}
            </>
        );
}

export default AppLayout;
